/**
 * @module
 */

import {click, FormController, location, reactive, service} from 'nova';
import {CHANGE, on} from '@acng/frontend-bounty/dom/event.js';
import {all} from '@acng/frontend-bounty/std/control.js';
import {guard, INTERFACE, IS_INPUT} from '@acng/frontend-rubicon';
import {make, t, localStore, UserProfileImageApi, USER_IMAGE_CROP} from './api.js';
import {UserImageCrop} from './crop.js';
import {UserImageWaiting} from './waiting.js';

@service
class UserImageUpload extends FormController {
  crop = new UserImageCrop();
  waiting = new UserImageWaiting();
  placeholder = '';
  @reactive accessor filename = '';
  // @reactive accessor filesize = '';
  #api = make(UserProfileImageApi);

  /** @override */
  async compile() {
    const [placeholder, waiting] = await all([
      t('core.chooseFile'), //
      this.#api.get(),
    ]);

    this.placeholder = `${placeholder}...`;
    this.filename = this.placeholder;
    this.waiting.set(waiting);

    DEBUG: {
      // IAPI
      const that = this;
      this.TEST = new (class {
        @reactive accessor active = true;

        /** @param {boolean} [accepted] */
        async #accept(accepted) {
          this.active = false;

          if (accepted === undefined) {
            return;
          }

          const init = {
            method: 'PUT',
            headers: {'Content-Type': 'application/json'},
            body: `{"accepted": ${accepted}, "fsk": 18}`,
          };

          fetch(`/iapi/user-image/waiting/${that.waiting.id}`, init);
        }

        @click accept() {
          this.#accept(true);
        }
        @click decline() {
          this.#accept(false);
        }
        @click cancel() {
          this.#accept();
        }
      })();
    }
  }

  /** @override @param {HTMLFormElement} form */
  upgrade(form) {
    ASSERT: guard(form.elements, INTERFACE({image: IS_INPUT}));
    const {image} = form.elements;

    image.required = true;
    image.type = 'file';
    image.accept = 'image/jpeg';

    on(image, CHANGE, () => {
      const file = image.files?.[0];

      if (!file) {
        this.filename = this.placeholder;
        delete localStore[USER_IMAGE_CROP];

        return;
      }

      this.crop.setup('/profile',  URL.createObjectURL(file));
      this.filename = file.name;
    });
  }

  /**
   * @override
   */
  async submit() {
    this.filename = this.placeholder;
    location.href = `/profile/image-crop`;
  }
}

export {UserImageUpload};
